import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CMIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CM" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#E11C1B"
        fillRule="evenodd"
        d="M4.8 0h6.4v12H4.8V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="m8.038 7.245-1.743 1.21.557-2.071-1.28-1.323 1.733-.071.733-2.048.733 2.048h1.73L9.223 6.384l.639 1.948-1.825-1.087Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FBCD17"
        fillRule="evenodd"
        d="M11.2 0H16v12h-4.8V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#0B9E7A"
        fillRule="evenodd"
        d="M0 0h4.8v12H0V0Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
